import { render, staticRenderFns } from "./ActivityLogWrapper.vue?vue&type=template&id=8451d8c4&"
import script from "./ActivityLogWrapper.vue?vue&type=script&lang=ts&"
export * from "./ActivityLogWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports